import { call } from "../helpers/axiosInterceptor";

// Get all activity logs with optional filtering
export const getActivityLogs = async (filters = {}) => {
  try {
    const token = localStorage.getItem("refToken");
    const { data } = await call.get("activity-logs", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: filters,
    });
    return data.data || [];
  } catch (error) {
    console.error("Error fetching activity logs:", error);
    return [];
  }
};

// Get activity logs for a specific entity (e.g., batch, course)
export const getEntityActivityLogs = async (entityType, entityId) => {
  try {
    const token = localStorage.getItem("refToken");
    const { data } = await call.get(`activity-logs/${entityType}/${entityId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data || [];
  } catch (error) {
    console.error(`Error fetching ${entityType} activity logs:`, error);
    return [];
  }
};